import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import { PaymentForm } from "./PaymentForm";
import { PaymentResult } from "./PaymentResult";
import { PaymentSuccess } from "../components/PaymentSuccess";
import { PaymentFail } from "../components/PaymentFail";


export const PaymentManagement = () => {

  const suhbeader = useSubheader();
  suhbeader.setTitle("Payment Management");
  
  return (
    <>
      <div className="row">
        <div className="col-12">
          <Switch>
            <Redirect
              from="/payment-management"
              exact={true}
              to="/payment-management/payment-form"
            /> 
            <Route
              path="/payment-management/payment-form"
              component={PaymentForm}
            />
            <Route
              path="/payment-management/payment-result"
              component={PaymentResult}
            />
            <Route
              path="/payment-management/payment-successful"
              component={PaymentSuccess}
            />
            <Route
              path="/payment-management/payment-failed"
              component={PaymentFail}
            />
          </Switch>
        </div>
      </div>
    </>
  );
};